import classNames from 'classnames';

import {ImageSkeleton, BlockSkeleton, TextSkeleton} from '@udemy/react-reveal-components';

import styles from './topic-header-skeleton.module.less';

export const TopicHeaderSkeleton = () => {
    return (
        <div className={classNames(styles['skeleton-container'], 'ud-container')}>
            <BlockSkeleton className={styles['title-block']} />

            <TextSkeleton
                className={styles['text-lines']}
                lineCountPerParagraph={4}
                paragraphCount={1}
            />

            <div className={styles['hero-image']}>
                <ImageSkeleton />
            </div>

            <div className={styles.rows}>
                <BlockSkeleton className={styles['row-block']} />
                <BlockSkeleton className={styles['row-block']} />
                <BlockSkeleton className={styles['row-block']} />
                <BlockSkeleton className={styles['row-block']} />
            </div>
        </div>
    );
};
